module.exports = __webpack_public_path__ + "media/audio7.f60780bb.mp3";